export default __webpack_public_path__ + "static/media/Graphik-MediumItalic.55f9a34d.otf";